import React, {Component} from "react";
import '../resources/nuro-icons.css';
import {Button} from "react-bootstrap";
import Table from "react-table";
import "react-table/react-table.css";
import DeviceDetailPopup from "../components/DeviceDetailPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownloadAlt, faRecycle, faCog } from "@fortawesome/free-solid-svg-icons";

export default class UserDataTable extends Component {

    static defaultProps = {
        keyField: "id"
    };
    state = {
        show : false,
        deviceConfigShow: false,
        mac : '',
        userId: '',
        premiseName: '',
       
    };

    columns = [
        {
            Header: "Rooms",
            accessor: "areaName",
            width: 75
        },
        {
            Header: "Device",
            accessor: "deviceName"
	    },
        {
            Header: "MAC",
            accessor: "mac"
        },
        {
            Header: "Type",
            accessor: "type",
            width: 50
        },
        {
            Header: "Subtype",
            accessor: "subType",
            width: 50
        },
        {
            Header: "Connected",
            accessor: "connected",
            width: 100
        },
        {
            Header: "LUX",
            accessor: "lux",
            width: 40
        },
        {
            Header: "Occ.",
            accessor: "occupancy",
            width: 50
        },
        {
            Header: "Load",
            accessor: "loadLevel",
            width: 40
        },
        {
            Header: "Version",
            accessor: "cpuVersion",
            width: 60
        },
        {
            Header: "STM",
            accessor: "stmVersion",
            width: 50
        },
        {
            Header: "WIFI",
            accessor: "wifiVersion",
            width: 50
        },
        {
            Header: "Mode",
            accessor: "mode",
            width: 50,
            Cell: (row) => ((row.original.mac)? (this.DeviceMode(row.original.mode)) : null )
        },
        {
            Header: "Details",
            Cell: (row) => ((row.original.mac)? (
            <DeviceDetailPopup deviceState = {row.original.rawShadow} >
            </DeviceDetailPopup>)
            :
             null ),
            width: 50
        },
        {
            Header: "Reboot",
            Cell: (row) => ((row.original.mac)? (
                <Button variant="info" onClick = {()=>this.props.onRebootClicked(row.original.mac)}><FontAwesomeIcon icon={faRecycle}/></Button>)
                :
                 null ),
                width: 50
        },
        {
            Header: "PIR",
            Cell: (row) => ((row.original.mac)? ( 
                <Button variant="info" onClick = {()=>this.props.onGetPirDataClicked(row.original.mac)}><FontAwesomeIcon icon={faCloudDownloadAlt}/></Button>)
                :
                 null ),
                width: 50
        },
        {
            Header: "Config",
            Cell: (row) => 
            ((row.original.mac) ? ( 
                <Button variant="info" onClick = {()=>this.checkDeviceClicked(row.original.mac, row.original.deviceName, row.original.deviceAreaName, row.original.cpuVersion)}><FontAwesomeIcon icon={faCog}/></Button>
            )
            :
                null),
            width: 50
        }
        // ,
        // {
        //     Header: "Unpair",
        //     Cell: (row) => ((row.original.mac)? (
        //         <Button variant="danger" onClick = {()=>this.props.onUnpairClicked(row.original.id)}><FontAwesomeIcon icon={faTimes}/></Button>)
        //         :
        //          null ),
        //         width: 50
        // }
    ];

    /**
     * To get device mode : 
     * 2 = Auto ,
     * 8,9 = sleep ,
     * 6 = scene 
     * any other number = Manual 
     * @param {*} mode 
     */
    DeviceMode (mode) {
        if(mode === 2) {
            return "Auto";
        } else if( mode === 8 || mode === 9) {
            return "Sleep";
        } else if(mode === 6 ) {
            return "Scene";
        } else {
            return "Manual";
        }

    }

    render() {
        return (
            <Table
                columns={this.columns}
                data={this.props.selectedPremise.areas}
                defaultPageSize={100}
            />
        )
    }

    checkDeviceClicked(mac, deviceName, deviceAreaName, cpuVersion){
        if(cpuVersion !== undefined && cpuVersion !== "" && cpuVersion.split(".")[0] === "4"){  
            this.props.onConfigClicked(mac, deviceName, deviceAreaName, true);
        }else{
            this.props.onConfigClicked(null, null, null, false);
        }
    }; 

}